import React, { useEffect, useState } from 'react';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import IconButton from '@mui/material/IconButton'; // Import IconButton for close button
import CloseIcon from '@mui/icons-material/Close'; // Import CloseIcon for close button icon
import SystemServices from 'services/System';
import { ErrorToaster, SuccessToaster } from 'components/Toaster';

const EmailModal = ({ open, onClose, id }) => {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);

    const handleEmailChange = (event) => {
        setEmail(event.target.value);
    };

    const handleForward = async () => {
        try {
            if (!email) {
                console.error('Email must be provided');
                return;
            }
            const encode = btoa(id.id)
            setLoading(true);
            const response = await SystemServices.forwardToPDFEmail({
                customer_email: email,
                message: `${window.location.origin}/${id.path}/${encode}`
            });

            console.log('Email API response:', response);

            setLoading(false);
            SuccessToaster(response?.message);
            onClose();
            setEmail('');
        } catch (error) {
            ErrorToaster(error);
            console.error('Error forwarding to Email:', error);
            setLoading(false);
        }
    };

    useEffect(() => {
        if (open) {
            setEmail('');
        }
    }, [open]);

    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="forward-to-email-modal"
            aria-describedby="forward-to-email-modal-description"
        >
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 400,
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    p: 4,
                    textAlign: 'center',
                }}
            >
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <IconButton
                        aria-label="close"
                        onClick={onClose}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: 'action',
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </div>
                <h2 id="forward-to-email-modal">Invoice Forward To Email</h2>
                <TextField
                    id="email"
                    label="Email"
                    variant="outlined"
                    value={email}
                    onChange={handleEmailChange}
                    fullWidth
                    sx={{ mt: 2 }}
                />
                {loading ? (
                    <CircularProgress sx={{ mt: 2 }} />
                ) : (
                    <Button variant="contained" onClick={handleForward} sx={{ mt: 2 }}>
                        Forward
                    </Button>
                )}
            </Box>
        </Modal>
    );
};

export default EmailModal;
